// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  NotificationPreference,
  NotificationPreferenceFromJSON,
  NotificationPreferenceToJSON,
  NotificationPreferencePayload,
  NotificationPreferencePayloadFromJSON,
  NotificationPreferencePayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CreateNotificationPreferenceRequest {
  notificationPreferencePayload?: NotificationPreferencePayload;
}

export interface GetMyNotificationPreferenceRequest {
  company: number;
}

export interface GetNotificationPreferenceRequest {
  id: number;
}

export interface UpdateNotificationPreferenceRequest {
  id: number;
  notificationPreferencePayload?: NotificationPreferencePayload;
}

/**
 * no description
 */
export class NotificationpreferenecsApi extends runtime.BaseAPI {
  /**
   * Add notification preference
   * Create a new notification preference
   */
  async createNotificationPreferenceRaw(
    requestParameters: CreateNotificationPreferenceRequest
  ): Promise<runtime.ApiResponse<NotificationPreference>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/notificationpreferences`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NotificationPreferencePayloadToJSON(
        requestParameters.notificationPreferencePayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NotificationPreferenceFromJSON(jsonValue)
    );
  }

  /**
   * Add notification preference
   * Create a new notification preference
   */
  async createNotificationPreference(
    requestParameters: CreateNotificationPreferenceRequest
  ): Promise<NotificationPreference> {
    const response = await this.createNotificationPreferenceRaw(
      requestParameters
    );
    return await response.value();
  }

  /**
   * Get a notification preference
   */
  async getMyNotificationPreferenceRaw(
    requestParameters: GetMyNotificationPreferenceRequest
  ): Promise<runtime.ApiResponse<NotificationPreference>> {
    if (
      requestParameters.company === null ||
      requestParameters.company === undefined
    ) {
      throw new runtime.RequiredError(
        "company",
        "Required parameter requestParameters.company was null or undefined when calling getMyNotificationPreference."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.company !== undefined) {
      queryParameters["company"] = requestParameters.company;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/notificationpreferences/myPreferences`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NotificationPreferenceFromJSON(jsonValue)
    );
  }

  /**
   * Get a notification preference
   */
  async getMyNotificationPreference(
    requestParameters: GetMyNotificationPreferenceRequest
  ): Promise<NotificationPreference> {
    const response = await this.getMyNotificationPreferenceRaw(
      requestParameters
    );
    return await response.value();
  }

  /**
   * Get a notification preference
   */
  async getNotificationPreferenceRaw(
    requestParameters: GetNotificationPreferenceRequest
  ): Promise<runtime.ApiResponse<NotificationPreference>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getNotificationPreference."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/notificationpreferences/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NotificationPreferenceFromJSON(jsonValue)
    );
  }

  /**
   * Get a notification preference
   */
  async getNotificationPreference(
    requestParameters: GetNotificationPreferenceRequest
  ): Promise<NotificationPreference> {
    const response = await this.getNotificationPreferenceRaw(requestParameters);
    return await response.value();
  }

  /**
   * Update notification preference
   */
  async updateNotificationPreferenceRaw(
    requestParameters: UpdateNotificationPreferenceRequest
  ): Promise<runtime.ApiResponse<NotificationPreference>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateNotificationPreference."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/notificationpreferences/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: NotificationPreferencePayloadToJSON(
        requestParameters.notificationPreferencePayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NotificationPreferenceFromJSON(jsonValue)
    );
  }

  /**
   * Update notification preference
   */
  async updateNotificationPreference(
    requestParameters: UpdateNotificationPreferenceRequest
  ): Promise<NotificationPreference> {
    const response = await this.updateNotificationPreferenceRaw(
      requestParameters
    );
    return await response.value();
  }
}
